import type { ReactNode } from 'react';

import { ElevatedPaper } from '@ui/components/papers/elevatedPaper';
import { Typography } from '@ui/components/texts/Typography';
import { cn } from '@ui/lib/utils';

const CARD_CLASSES = 'w-100 max-w-[90vw] p-10';

const AUTH_BUTTON_CLASSES = 'h-12 w-full';

interface AuthCardProps {
  title?: string;
  children: ReactNode;
  className?: string;
}

const AuthCard = ({ title, children, className }: AuthCardProps) => (
  <ElevatedPaper className={cn(CARD_CLASSES, className)}>
    {title && (
      <Typography as="h3" className="mb-2.5">
        {title}
      </Typography>
    )}
    {children}
  </ElevatedPaper>
);

export { AUTH_BUTTON_CLASSES, AuthCard };
export type { AuthCardProps };
